import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const textField = (theme: Theme) => ({
  "& input:-webkit-autofill": {
    WebkitBoxShadow: `0 0 0 30px ${theme.palette.login.autofill} inset !important`,
    backgroundColor: "transparent",
    backgroundImage: "none !important",
    color: `${theme.palette.common.black} !important`,
  },
  "& .MuiOutlinedInput-root": {
    width: "385px",
    height: "56px",
  },
});

export const useLoginStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100vh",
    width: "100%",
    position: "relative",
  },
  main: {
    display: "flex",
    justifyContent: "space-around",
    height: "100vh",
  },
  leftMain: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    backgroundColor: theme.palette.background.paper,
  },
  left: {
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "100%",
    padding: "0 24px",
  },
  loginTexts: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
  MedicalCareText: {
    fontWeight: 400,
    fontSize: "26px",
    lineHeight: "140%",
    color: theme.palette.login.heading,
    fontFamily: theme.typography.fontFamily,
    width: "auto",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  formPanel: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "5rem",
    background: theme.palette.background.default,
  },
  right: {
    background: theme.palette.background.default,
    padding: "26px 40px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  error: {
    width: "100%",
    textAlign: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  welcomeRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
  },
  loginText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "32px",
    fontWeight: 500,
    color: theme.palette.login.heading,
    marginLeft: "30px",
    paddingBottom: "12px",
    letterSpacing: "0.03em",
  },
  brandName: {
    color: theme.palette.login.brand,
    fontSize: "42px",
    fontWeight: 800,
  },
  fields: {
    display: "flex",
    flexDirection: "column",
  },
  email: {
    ...textField(theme),
    marginTop: 0,
    marginBottom: 23,
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "6px",
    },
  },
  password: {
    ...textField(theme),
    margin: 0,
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "4px",
    },
  },
  helperStart: {
    textAlign: "left",
  },
  helperEnd: {
    textAlign: "right",
  },
  forgotWrap: {
    margin: "5px 0 24px",
  },
  forgotPassword: {
    color: theme.palette.login.link,
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    textDecoration: "underline",
  },
}));
